// Nombre visible del proveedor de una capa.
// Se comparte entre el listado de capas y la pantalla de edición para que el usuario lea
// siempre la misma palabra: la edición muestra un formulario distinto según el proveedor y
// sin esa etiqueta la diferencia parece arbitraria (QA-72).

export const LAYER_PROVIDER_LABELS = {
  geoserver: 'GeoServer',
  arcgis: 'ArcGIS',
  // Compatibilidad con capas antiguas cargadas como archivo, que usan
  // el mismo flujo de datos y edición de GeoServer.
  file: 'GeoServer'
}

export function layerProviderLabel (layer) {
  const providerName = layer && layer.provider && layer.provider.name
    ? String(layer.provider.name).trim().toLowerCase()
    : ''
  return LAYER_PROVIDER_LABELS[providerName] || 'Sin información'
}
